<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <div class="times">
          <Times @getTime="getTime" ref="times"></Times>
          <el-form :model="query" ref="queryForm" :inline="true">
            <el-form-item :label="navIndex==0?'团队成员：':'客户信息：'">
              <el-input v-model="query.nameOrPho" placeholder="请输入姓名/手机号" clearable size="small" />
            </el-form-item>
            <el-form-item label="身份：">
              <el-select v-model="query.levelId" placeholder="请选择" clearable size="small">
                <el-option :label="item.name" :value="item.level" v-for="(item,index) in identityList" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="btns">
          <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
          <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          <el-button type="primary" icon="el-icon-arrow-left" @click="goBack" size="mini">返回上一页</el-button>
        </div>
      </div>
      <div class="nav-container">
        <Navs ref="navs" :navList="navList" @changeNav="changeNav" @exportEv="exportEv"></Navs>
      </div>
      <div class="data-container mt20">
        <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
          <!-- <el-table-column label="排名" type="index" align="center" width="60"></el-table-column> -->
          <el-table-column :label="navIndex==0?'团队成员':'客户信息'" prop="name" align="center">
            <template slot-scope="{row}">
              <div v-if="navIndex==0">
                <span style="display: block;">{{ row.realName }}</span>
                <span style="display: block;">{{ row.mobile }}</span>
              </div>
              <div v-else>
           
                <span style="display: block;">{{ row.name }}</span>
                <span style="display: block;">{{ row.pho }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="身份" prop="levelName" align="center"></el-table-column>
          <el-table-column label="用友编码" prop="Code" align="center" v-if="navIndex"></el-table-column>
          <el-table-column label="总业绩" prop="performance" sortable="custom" align="center"></el-table-column>
          <el-table-column label="订货业绩" prop="performanceForType1" sortable="custom" align="center"></el-table-column>
          <el-table-column label="秒杀业绩" prop="performanceForType2" sortable="custom" align="center"></el-table-column>
          <!-- <el-table-column label="充值业绩" prop="czAchievement" sortable="custom" align="center"></el-table-column>
          <el-table-column label="学费业绩" prop="xfAchievement" sortable="custom" align="center"></el-table-column>
          <el-table-column label="课程业绩" prop="kcAchievement" sortable="custom" align="center" width="100"></el-table-column> -->
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      </div>
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import Times from '../../components/times.vue'
import Navs from '../../components/navs.vue'
import customerLevelApi from '@/api/sys/customerLevel'
import clientListApi from '@/api/client/clientList'
import enums from '@/utils/enums'
export default {
  components: {
    Pagination,
    Times,
    Navs
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        performanceSortSign: -1
      },
      selectItems: [],
      times: null,
      navList: [
        { name: '团队业绩', id: 1 },
        { name: '客户业绩', id: 2 }
      ],
      navIndex: 0,
      identityList: [],
      today: '',
      id: null,
      isServiceTeacher: 0
    }
  },
  created() {
    let queryObj = this.$route.query;
    if (queryObj.index) this.navIndex = queryObj.index;
    if (queryObj.id) this.id = +queryObj.id;
    if (queryObj.isServiceTeacher) this.isServiceTeacher = +queryObj.isServiceTeacher
  },
  mounted() {
    this.$refs.navs.navIndex = this.navIndex * 1;
    this.today = this.dayjs().format('YYYY-MM-DD');
    this.times = {
      timeStart: `${this.today} 00:00:00`,
      timeEnd: `${this.today} 23:59:59`,
    }
    this.doQueryList({ pageNo: 1 })
    this.getIdentityList()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    // 获取身份列表
    getIdentityList() {
      const searchUserLevel = enums.getSearchUserLevel()
      this.identityList = Object.values(searchUserLevel).map(item => ({
        id: item.value,
        level: item.value,
        name: item.label
      }))
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
     sortChange({ prop, order }) {
      const sortKeyMap = {
        'performance': 'performanceSortSign',
        'performanceForType1': 'performanceForType1SortSign',
        'performanceForType2': 'performanceForType2SortSign',
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else if (order === 'descending') {
            this.query[sortKey] = -1
          } else {
            this.query[sortKey] = 0
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 获取时间段
     */
    getTime(event) {
      this.times = JSON.parse(event)
      if (!this.times.ifUse) {
        this.doQueryList({ pageNo: 1 })
      }
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发重置操作
     */
    handleFilter() {
      this.$refs.times.timeIndex = 0
      this.$refs.times.timeShow = ''
      this.$refs.times.timeStart = ''
      this.$refs.times.timeEnd = ''
      this.query = {
        pageNo: 1,
        pageSize: 10,
        performanceSortSign: -1
      }
      this.times = {
        timeStart: `${this.today} 00:00:00`,
        timeEnd: `${this.today} 23:59:59`,
      }
    },
    /**
     * 触发导航切换
     */
    changeNav(index) {
      this.navIndex = index;
      this.doQueryList({ pageNo: 1 });
    },
    /**
     * 触发导出
     */
    exportEv() {
      this.$router.push('/count/technology/export')
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = { ...this.query }
      query.viewType = this.navList[this.navIndex].id
      if (this.times && this.times.timeStart) {
        query.startTime = this.times.timeStart
        query.endTime = this.times.timeEnd
      }
      // 客户业绩时传递对应的技术老师ID参数
      if (query.viewType === 2) {
        if (this.isServiceTeacher) {
          query.technicianIdForBig = this.id
        } else {
          query.technicianId = this.id
        }
      }else{
        query.parentId = this.id
      }
      this.listLoading = true
      // 根据viewType选择不同的接口
      if (query.viewType === 2) {
        // 客户业绩使用专门的接口 /cust/customer/tee/listForStatistics
        return clientListApi.listForStatistics(query).then(({ data }) => {
          this.list = data.list
          this.total = data.total
        }).finally(() => {
          this.listLoading = false
        })
      } else {
        // 团队业绩根据身份选择接口
        if(this.isServiceTeacher){
          return clientListApi.getlistForStatisticsBig(query).then(({ data }) => {
            this.list = data.list
            this.total = data.total
          }).finally(() => {
            this.listLoading = false
          })
        } else {
          // 普通技术老师的团队业绩
          let Ins = clientListApi.getTechTeamStatistics
          return Ins(query).then(({ data }) => {
            this.list = data.list
            this.total = data.total
          }).finally(() => {
            this.listLoading = false
          })
        }
      }
    },
    // changeSwitch(row) {
    //   sysDataconstantApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
    //     this.$common.showMsg('success', '操作成功')
    //   })
    // },
    /**
     * 页面跳转
     */
    toPage(path, row, type) {
      if (type) {
        this.$router.push(`${path}?id=${row.id}&index=${type - 1}`)
      } else {
        this.$router.push(`${path}?id=${row.id}`)
      }
      window.location.reload();
    }
  }
}
</script>
<style scoped lang="scss">
.filter-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 0;
  .times {
    display: flex;
    align-items: center;
  }
  .btns {
    margin-bottom: 22px;
  }
}
</style>
